import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  GetSystemTemplatesResponse,
  SystemTemplate,
} from 'models/automation/SystemTemplates';
import API from 'services/API';
import { API_MAX_LIMIT } from 'services/API.constants';

export const SYSTEM_TEMPLATES_BASE_QUERY_KEY = 'system-templates';

type ReactQueryOptions = Omit<
  UseQueryOptions<SystemTemplate[]>,
  'queryKey' | 'queryFn'
>;

type UseFetchSystemTemplatesArgs = {
  limit?: number;
} & ReactQueryOptions;

const useFetchSystemTemplates = ({
  limit = API_MAX_LIMIT,
  enabled = true,
  ...options
}: UseFetchSystemTemplatesArgs = {}) => {
  return useAppQuery<SystemTemplate[]>({
    queryKey: [SYSTEM_TEMPLATES_BASE_QUERY_KEY, 'list'],
    queryFn: async () => {
      const response = await API.get<GetSystemTemplatesResponse>(
        '/api/internal/automation/system-templates',
        { params: { _limit: limit } },
      );

      return response.data.templates;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchSystemTemplates;
